import styled from 'styled-components'
import {
  PRIMARY_BLUE_02,
  GRAY_SCALE_09,
  GRAY_SCALE_04,
  GRAY_SCALE_05,
  GRAY_SCALE_08,
  PRIMARY_RED_10,
  SECONDARY_BLUE_10,
  PRIMARY_BLUE_01,
  GRAY_SCALE_10,
  SECONDARY_BLUE_01,
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'
import CalendarDashboard from '../../components/Calendar'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const ContainerBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  max-width: 100%;
  padding: 32px;
  margin-top: 42px;
  background-color: ${GRAY_SCALE_10};
  border-radius: 8px;
  border: 1px solid ${GRAY_SCALE_09};
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const ContentBox = styled.div`
  width: 50%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const FormDivider = styled.div`
  background-color: ${GRAY_SCALE_08};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  @media (max-width: 768px) {
    margin-top: 29px;
  }
`

export const PageSubtitle = styled.p`
  color: ${GRAY_SCALE_05};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const PageTitle = styled.h4`
  color: ${PRIMARY_BLUE_02};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-bottom: 13px;
  }
`

export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
    margin-top: 25px;
  }
`

export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`

export const PageOptions = styled.h5`
  color: ${PRIMARY_BLUE_02};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  margin-top: 32px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 13px;
  }
`

export const ContainerButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  @media (max-width: 1152px) {
    justify-content: center;
  }
`

export const ContainerCard = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 50%;
  @media (max-width: 1152px) {
    width: 100%;
  }
`

export const DetailCard = styled.div`
  display: flex;
  height: 85px;

  border: 1px solid ${GRAY_SCALE_09};
  border-radius: 5px;
  padding: 0px 30px;
  margin-top: 8px;

  @media (max-width: 1152px) {
    width: 100%;
  }
`

export const LabelCard = styled.div`
  color: ${GRAY_SCALE_04};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0 30px;
  align-content: center;
`

export const CardTitle = styled.div`
  color: ${PRIMARY_BLUE_02};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.6px;
  margin-top: 4px;
`

export const BoxTitle = styled.div`
  color: ${PRIMARY_BLUE_01};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
`

export const BoxSubtitle = styled.div`
  color: ${PRIMARY_BLUE_01};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  margin-bottom: 26px;
`

export const ContractServiceButton = styled.button`
  color: ${WHITE};
  background: ${SECONDARY_BLUE_01};
  height: 48px;
  maxwidth: 100%;
  variant: contained;
  width: 252px;
  border-radius: 19px;
  border-color: transparent;
`

export const IconDetailContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  &:before {
    content: '';
    width: 42px;
    height: 42px;
    background-color: ${PRIMARY_RED_10};
    border-radius: 100px;
    position: absolute;
    z-index: 0;
  }
  & div {
    z-index: 1;
  }
  &.graph {
    &:before {
      background-color: ${SECONDARY_BLUE_10};
    }
  }
`

export const ImgBdCrmBonus = styled.img`
  width: 50%;
  height: content-fit;
  padding-left: 32px;
  align-self: center;
  @media (max-width: 768px) {
    width: 100%;
    padding: 15px 0;
  }
`;

export const CalendarDashboardStyled = styled(CalendarDashboard)`
  background: ${WHITE};
  max-width: 80px;
  .CalendarIcon {
    background-color: black;
    filter: invert(1);
  }
  &.hidden {
    display: none;
  }
`